module.exports = __webpack_public_path__ + "87d280781ea8d11c2a1b2fd6433d4369.svg";